// extracted by mini-css-extract-plugin
export default {"card":"R4-z"};